import React from 'react';
import { getdata, updatedata } from "../../util/global";

/**
 * PatientAdminTable
 * Following the Constitution: Table-only data display and Action Select pattern.
 */
const PatientAdminTable = ({ data, openview, openedit }) => {



  const updatestatusdelete = async (patient) => {
    if (!confirm("Delete : " + patient.name + " ? ")) {
      return false;
    }
    const payload = {
      data: {
        _id: patient._id,
        status:"deleted",
        datatype: "patientdata",
        appname: window.APPSETTING?.appname
      }
    };

    let res = await updatedata(payload);
    console.log(res);
    $("#" + patient._id + "row").remove();
    setmode("");
  };


  return (
    <table className="grid">
      <thead>
        <tr>
          <th style={{ width: '50px' }}>Action</th>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {data.map((patient, i) => (
          <tr key={patient._id || i} id={patient._id + "row"}>
            <td>
              {/* Institutional-Grade Action Select pattern */}
              <select 
                className="action-select" 
                value="" 
                onChange={(e) => {
                  if (e.target.value === "View") openview(patient);
                  if (e.target.value === "Edit") openedit(patient);
                  if (e.target.value === "Delete") updatestatusdelete(patient);

                }}
              >
                <option value="" disabled>{i + 1}</option>
                <option value="View">View</option>
                <option value="Edit">Edit</option>
                <option value="Delete">Delete</option>

              </select>
            </td>
            <td>{patient.name}</td>
            <td>{patient.phonenumber}</td>
            <td>
              <span className={`status-badge ${patient.status?.toLowerCase() || 'active'}`}>
                {patient.status || "Active"}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PatientAdminTable;